var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',_vm._l((_vm.children),function(child){return _c('li',{attrs:{"track-by":"$index"}},[(child.children)?_c('routes-list',{attrs:{"item":child}}):_c('span',[_vm._v("\n                Name: "+_vm._s(child.name)),_c('br'),_vm._v("\n                URL: "+_vm._s(child.path)+"\n            ")])],1)}),0)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96c28b60","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Debug/Routes/RoutesListItems.vue
// module id = 653
// module chunks = 52